<template>
    <div class="pt-2">
        <v-card v-if="showStatusInputCard" class="pa-6">
            <h3 class="text-h6 font-weight-bold">Update Status</h3>
            <p class="text-body-2 text-grey mb-4">
                Update the work status and add notes. Choose whether this update is visible to the client.
            </p>

            <v-row class="pt-4">
                <v-col cols="12" md="3">
                    <h3>Status <span class="red--text">* </span></h3>
                    <v-select @change="sendToParent" :items="statuslist" v-model="selectedStatus" item-text="status"
                        item-value="timeline_status_id" outlined dense />
                </v-col>

                <v-col cols="12" md="3" v-if="showReportInv">
                    <h3>Reported / Invoiced</h3>
                    <v-select v-model="showaddItem.report" :items="reportlist" item-text="report_name"
                        item-value="report_value" outlined dense></v-select>
                </v-col>

                <v-col cols="12" md="3">
                    <h3>Case worker</h3>
                    <v-text-field v-model="caseWorkerName" disabled background-color="#F5F5F5" outlined
                        dense></v-text-field>
                </v-col>

                <v-col cols="12" md="3">
                    <h3>Status Time</h3>
                    <v-text-field v-model="currentDateTime" background-color="#F5F5F5" outlined dense
                        disabled></v-text-field>
                </v-col>

                <v-col cols="12" md="6">
                    <h3>Status Note <span class="red--text">* </span></h3>
                    <v-textarea v-model="localStatusNote" rows="3" outlined dense />
                </v-col>

                <v-col cols="12" md="6" class="mt-5">
                    <div class="title-line">
                        <h4 class="font-weight-bold mb-0">Client Visibility</h4>
                    </div>
                    <p class="text-body-2 text-grey mt-1">
                        Choose whether this update is visible to the client.
                    </p>

                    <v-switch v-model="visible" label="Show this update on client progress page" color="#0953E5" inset
                        class="small-switch" style="margin-top: -10px;" />
                </v-col>
            </v-row>

            <!-- <div class="d-flex justify-end mt-3" style="border-top: 1px solid #E0E0E0;">
                <v-row class="mt-2" justify="end" dense>
                    <v-btn depressed outlined text width="140" class="mr-4" style="text-transform: none;">
                        Cancel
                    </v-btn>

                    <v-btn color="#0953E5" width="140" style="color: white; text-transform: none;">
                        Save Update
                    </v-btn>
                </v-row>
            </div> -->
        </v-card>

        <!-- Timeline + Summary -->
        <v-row class="mt-1" v-if="this.modeOperations != 'New'">
            <!-- Timeline -->
            <!-- Timeline -->
            <v-col cols="12" md="8">
                <v-card variant="outlined" class="pa-4">
                    <h3 class="text-h6 font-weight-bold mb-4">Timeline</h3>

                    <div class="timeline-wrapper">

                        <!-- เส้นกลางเส้นเดียว -->
                        <div class="timeline-main-line"></div>

                        <div v-for="(item, index) in timelineData" :key="index" class="timeline-row">
                            <!-- icon -->
                            <div class="timeline-left">
                                <div class="timeline-icon" :style="{ backgroundColor: item.icon_color }">
                                    <v-icon color="white" size="20">
                                        {{ item.icon }}
                                    </v-icon>
                                </div>
                            </div>

                            <!-- card -->
                            <div class="timeline-card-wrapper">
                                <v-card flat class="timeline-card pa-4 mb-4" :style="{ backgroundColor: item.color }">
                                    <div class="timeline-arrow" :style="{ borderRightColor: item.color }"></div>

                                    <v-row>
                                        <v-col cols="8">
                                            <div class="d-flex align-center mb-1" style="margin-top: -6px;">
                                                <span class="font-weight-bold mr-2">
                                                    {{ item.status }}
                                                </span>

                                                <v-chip v-if="item.visibility" small color="success"
                                                    class="caption px-2" style="height: 20px" outlined>
                                                    Visible to client
                                                </v-chip>
                                            </div>

                                            <p class="text-body-2 text-grey mb-1">
                                                {{ item.status_time }}
                                            </p>

                                            <p class="text-body-2" style="margin-bottom: -8px;">
                                                {{ item.status_note }}
                                            </p>
                                        </v-col>

                                        <v-col cols="4" class="text-right font-weight-bold">
                                            <p>{{ item.worker }}</p>
                                        </v-col>
                                    </v-row>
                                </v-card>
                            </div>
                        </div>
                    </div>
                </v-card>
            </v-col>

            <!-- Status Summary -->
            <v-col cols="12" md="4">
                <v-card variant="outlined" class="pa-4">
                    <h3 class="text-h6 font-weight-bold mb-4">
                        Status Summary
                    </h3>

                    <p class="text-body-2 text-grey">Current Status</p>

                    <div class="font-weight-bold d-flex align-center" style="margin-top: -10px;">
                        <div class="status-summary-icon" :style="{ backgroundColor: last_icon_color }">
                            <v-icon color="white" size="12">
                                {{ last_icon }}
                            </v-icon>
                        </div>

                        <span class="ml-2">{{ last_status }}</span>
                    </div>

                    <p class="text-body-2 text-grey mt-6 pl-6">Last Updated</p>
                    <p class="mb-14 pl-6" style="margin-top: -15px;">{{ last_time }}</p>

                    <v-divider class="my-4" />
                    <div v-if="dataCurrent && Object.keys(dataCurrent).length > 0">
                        <p class="text-body-2 text-grey ">
                            Client Progress (Latest Visible Update)
                        </p>

                        <v-card color="#F8FAFC" flat rounded="lg" class="pa-3 mt-0">
                            <p class="text-body-2">{{ dataCurrent.status_time }}</p>
                            <p class="font-weight-bold" style="margin-top: -10px;">{{ dataCurrent.status }}</p>
                            <p class="text-body-2" style="margin-top: -10px; margin-bottom: -5px;">
                                {{ dataCurrent.status_note }}
                            </p>
                        </v-card>
                    </div>
                    <v-row class="mt-4 justify-center mb-2" style="gap: 16px;">

                        <v-btn depressed outlined color="#0953E5" style="text-transform: none;" width="175"
                            @click="previewClientPreview">
                            <v-icon left size="18">mdi-eye</v-icon>
                            Preview as Client
                        </v-btn>

                        <v-btn depressed outlined color="#0953E5" style="text-transform: none;" width="175"
                            @click="copyLinkClientPreview">
                            <v-icon left size="18">mdi-link</v-icon>
                            Copy Client Link
                        </v-btn>

                    </v-row>
                </v-card>
            </v-col>
        </v-row>
        <v-snackbar v-model="snackbar" :color="snackbarColor" timeout="2000" top right>
            <v-icon left color="white">
                mdi-check-circle
            </v-icon>

            {{ snackbarText }}

            <template v-slot:action="{ attrs }">
                <v-btn text v-bind="attrs" @click="snackbar = false">
                    ปิด
                </v-btn>
            </template>
        </v-snackbar>
    </div>
</template>

<script>
import { server } from "@/services/constants";
import api from "@/services/api";
import Hashids from "hashids";
import PDFCaseProgress from "@/utils/pdfClientTimeLine";

export default {
    name: "TimeLineOperations",
    props: {
        showReportInv: {
            type: Boolean,
            required: true
        },
        visible_check: {
            type: Boolean,
            required: true
        },
        module_name: {
            type: String,
            required: true
        },
        status_note: {
            type: String,
            required: true
        },
        modeOperations: {
            type: String,
            required: true
        },
        timelineStatus: {
            type: Number,
            required: true
        },
        timeline_case_id: {
            type: Number,
            required: true
        },
        showaddItem: {
            type: Object,
            default: () => ({})
        },
        statuslist: {
            type: Array,
            default: () => []
        },
        reportlist: {
            type: Array,
            default: () => []
        },
        showStatusInputCard: {
            type: Boolean,
            default: true
        }
    },

    data() {
        return {
            localStatusNote: this.status_note,
            encodedid: "",
            snackbar: false,
            snackbarText: "",
            snackbarColor: "success",
            tab: 1,
            visible: null,
            currentDateTime: '',
            caseWorkerName: '',
            selectedStatus: 0,
            dataCurrent: {},
            last_time: "",
            last_status: "",
            last_icon: "",
            last_icon_color: "",
            cssStatus: [
                {
                    status: "In Progress",
                    color: "#FFF7ED",
                    icon_color: "#D97706",
                    icon: "mdi-loading"
                },
                {
                    status: "Waiting for Client",
                    color: "#FEFCE8",
                    icon_color: "#CA8A04",
                    icon: "mdi-message-alert-outline"
                },
                {
                    status: "Waiting for Third Party",
                    color: "#ECFEFF",
                    icon_color: "#0891B2",
                    icon: "mdi-timer-sand"
                },
                {
                    status: "Internal Review",
                    color: "#EEF2FF",
                    icon_color: "#4F46E5",
                    icon: "mdi-clipboard-check-outline"
                },
                {
                    status: "Payment Pending",
                    color: "#FFF7ED",
                    icon_color: "#EA580C",
                    icon: "mdi-credit-card-outline"
                },
                {
                    status: "Completed",
                    color: "#F0FDF4",
                    icon_color: "#16A34A",
                    icon: "mdi-check-circle"
                },
                {
                    status: "On Hold",
                    color: "#FEF2F2",
                    icon_color: "#DC2626",
                    icon: "mdi-pause-circle"
                },
                {
                    status: "Cancelled",
                    color: "#F8FAFC",
                    icon_color: "#475569",
                    icon: "mdi-close-circle"
                },
                {
                    status: "Closed",
                    color: "#F0FDF4",
                    icon_color: "#15803D",
                    icon: "mdi-archive"
                }
            ],
            timelineData: [
                // {
                //     status: "In Progress",
                //     icon: "mdi-loading",
                //     icon_color: "#D97706",
                //     color: "#FFF7ED",

                //     status_time: "15/05/2026 09:30 AM",
                //     status_note: "Work on this request has started and is currently being processed by the assigned team.",
                //     worker: "testname user",
                //     visibility: true,
                // },

            ]
        };
    },
    async mounted() {
        await this.initPage();

    },
    watch: {
        timelineStatus: {
            immediate: true,
            handler(val) {
                this.handleTimelineStatus(val);
            }
        },
        status_note: {
            immediate: true,
            handler(val) {
                this.localStatusNote = val;
            }
        },
        localStatusNote(val) {
            this.$emit("update:status_note", val);
        },
        visible_check: {
            immediate: true,
            handler(val) {
                this.visible = val;
            }
        },
        visible(val) {
            this.$emit("update:visible_check", val);
        }
    },
    methods: {
        async initPage() {
            this.$showLoader();

            try {
                var mainid = `${this.timeline_case_id}`;
                const hashids = new Hashids("my-secret-salt", 8);
                const encoded = hashids.encode(mainid);
                this.encodedid = encoded;

                this.caseWorkerName = await this.getCaseWorkerName();
                this.currentDateTime = this.getCurrentDateTime();
                if (this.modeOperations == "Edit") {
                    await this.loaddataTimeline();
                    await this.loaddataTimelineVisibility();
                }

            } catch (err) {
                console.error(err);
            } finally {
                this.$hideLoader();
            }
        },

        async getCaseWorkerName() {
            let workerName = "";

            const userId = localStorage.getItem(server.USER_ID);

            const result = await api.getAccountByid(userId);

            if (result?.data?.length > 0) {
                workerName = result.data[0].name;
            }

            return workerName;
        },

        getCurrentDateTime() {
            const now = new Date();

            const day = String(now.getDate()).padStart(2, '0');
            const month = String(now.getMonth() + 1).padStart(2, '0');
            const year = now.getFullYear();

            return `${day}/${month}/${year}`;
        },
        async copyLinkClientPreview() {
            try {
                this.$showLoader()
                const caseDetailResult = await api.getgetTimelineDataDetail({
                    params: {
                        module_name: this.module_name,
                        case_id: Number(this.timeline_case_id),
                    },
                });

                const caseInfo = { ...(caseDetailResult.data?.[0] || {}) };
                caseInfo.status = this.last_status;
                caseInfo.lastUpdated = this.last_time;

                const latestUpdate = {
                    message: this.dataCurrent?.status_note || '',
                    date: this.dataCurrent?.status_time || '',
                };

                const result = await PDFCaseProgress.createToPDF(
                    {
                        caseInfo,
                        latestUpdate,
                        timelineData: (this.timelineData || []).filter((item) => item.visibility === true),
                        caseId: this.timeline_case_id,
                        moduleName: this.module_name,
                    },
                    { open: false }
                );

                if (!result?.shortUrl) {
                    this.$hideLoader()
                    this.snackbarText = "สร้างลิงก์ไม่สำเร็จ ❌";
                    this.snackbarColor = "error";
                    this.snackbar = true;
                    return;
                }
                this.$hideLoader()
                await navigator.clipboard.writeText(result.shortUrl);
                this.snackbarText = "Copy สำเร็จ 🎉";
                this.snackbarColor = "success";
                this.snackbar = true;

            } catch (err) {
                this.$hideLoader()
                console.error("Copy failed:", err);
                this.snackbarText = "Copy ไม่สำเร็จ ❌";
                this.snackbarColor = "error";
                this.snackbar = true;
            }
        },
        previewClientPreview() {
            const localUrl = window.location.origin;

            const text = `${localUrl}/client-view/case/${this.encodedid}?module_name=${encodeURIComponent(this.module_name)}`;

            window.open(text, "_blank");
        },

        handleTimelineStatus(value) {
            if (Number(value) != 0) this.selectedStatus = String(value);
        },
        sendToParent(value) {
            // console.log(this.showaddItem.closed)

            const selectedItem = this.statuslist.find(
                item => Number(item.timeline_status_id) === Number(value)
            )

            this.$emit("timelineStatus", Number(value));
            if (this.module_name == "Corporate" || this.module_name == "Immigration") {
                this.$emit("requestStatus", selectedItem.module_id)
            } else {
                this.$emit("requestStatus", Number(selectedItem.module_id))
            }

        },
        async loaddataTimeline() {

            const result_timeline = await api.getgetClientTimelineHistoryShow({
                params: {
                    module_name: this.module_name,
                    case_id: Number(this.timeline_case_id),
                }
            })

            if (result_timeline.data && result_timeline.data.length > 0) {
                this.timelineData = result_timeline.data;
                this.last_time = result_timeline.data[0].status_time;
                this.last_status = result_timeline.data[0].status;
                this.last_icon = result_timeline.data[0].icon;
                this.last_icon_color = result_timeline.data[0].icon_color;
            }

        },
        async loaddataTimelineVisibility() {
            const result_timeline_visibility = await api.getgetClientTimelineHistoryShowVisibility({
                params: {
                    module_name: this.module_name,
                    case_id: Number(this.timeline_case_id),
                }
            })
            if (result_timeline_visibility.data && result_timeline_visibility.data.length > 0) {
                this.dataCurrent = result_timeline_visibility.data[0]
            }

        }
    }
};
</script>

<style scoped>
.text-grey {
    color: #6b7280;
}

/* wrapper */
.timeline-wrapper {
    position: relative;
}

/* เส้นกลางเส้นเดียว */
.timeline-main-line {
    position: absolute;
    top: 20px;
    /* เริ่มใต้ icon ตัวแรก */
    bottom: 100px;
    /* จบเหนือ icon ตัวสุดท้าย */
    left: 34px;
    /* กลาง icon */
    width: 2px;
    background: #d1d5db;
    z-index: 1;
}

/* row */
.timeline-row {
    display: flex;
    align-items: flex-start;
    position: relative;
}

/* left */
.timeline-left {
    width: 70px;
    display: flex;
    justify-content: center;
    position: relative;
    z-index: 2;
    margin-top: 3px;
}

/* icon */
.timeline-icon {
    width: 38px;
    height: 38px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 0 0 4px white;
}

/* right */
.timeline-card-wrapper {
    flex: 1;
    position: relative;
}

/* card */
.timeline-card {
    position: relative;
    margin-left: 14px;
    overflow: visible !important;
    border-radius: 12px;
}

/* arrow */
.timeline-arrow {
    position: absolute;
    top: 16px;
    left: -4px;

    width: 12px;
    height: 12px;

    background: inherit;
    /* ใช้สีเดียวกับ card */
    transform: rotate(45deg);

    border-radius: 1px;
    /* ทำให้มุมมน */
    z-index: 1;
}

.status-summary-icon {
    width: 17px;
    height: 17px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 0 0 4px white;
}

.title-line {
    display: flex;
    align-items: center;
    gap: 10px;
}

.title-line::after {
    content: "";
    flex: 1;
    height: 1px;
    background: #e0e0e0;
}
</style>